/* eslint-disable @typescript-eslint/camelcase */
import * as Rox from "rox-browser";

export const FlagsPermissionPusatResolusi = {
  permission_pusat_resolusi_v1_enable: new Rox.Flag(true),
  permission_pusat_resolusi_v1_detail: new Rox.Flag(true),
  permission_pusat_resolusi_v1_create: new Rox.Flag(true),
};


export function initFlagsPermissionPusatResolusi() {
  Rox.register("featurePusatResolusiV1", FlagsPermissionPusatResolusi);
}
